<template>
    <v-container fluid>
        <!-- Sheet title -->
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.title }}
            </v-row>
        </v-col>

        <v-row class="pl-4 pr-4 pt-3">
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- SHEET TYPE -->
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-sheet-type'"
                        >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_TYPE') }}:</div>
                        <div :alvqa="alvqa + '-sheet-type'">
                            {{item.type ==="film/tv" ? $t("lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_FILMTV") : $t("lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_SETLIST") }}
                        </div>

                        <!-- ALVID -->
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-alvid'"
                        >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                        <div :alvqa="alvqa + '-alvid'">
                            {{ item.alvId }}
                        </div>
                        <!-- TAGS -->
                        <span v-if="item.tag !== null && item.tag !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-tag'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_TAGS') }}:</div>
                            <div :alvqa="alvqa + '-tag'">
                                {{ item.tag }}
                            </div>
                        </span>
                        <!-- NOTES -->
                        <span v-if="item.note !== null && item.note !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-note'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_NOTE') }}:</div>
                            <div style="white-space: pre;"
                                :alvqa="alvqa + '-note'"
                                >{{ item.note }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>


            <!-- ******** SECOND COLUMN ******** -->
            <v-col v-if="item.type ==='film/tv' && showSecondTvSheetTypeCard">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- AV TYPE -->
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-av-type'"
                        >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_AV_TYPE') }}:</div>
                        <div :alvqa="alvqa + '-av-type'">
                            {{ item.avType != '' && item.avType != null ? item.avType : $t("lang_GENERIC_CAPTION_UNDEFINED") }}
                        </div>

                        <!-- Production year -->
                        <span v-if="item.productionYear !== null && item.productionYear !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-production-year'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_YEAR') }}:</div>
                            <div :alvqa="alvqa + '-production-year'">
                                {{ item.productionYear }}
                            </div>
                        </span>
                        <!-- First broadcast date -->
                        <span v-if="item.firstBroadcastDate !== null && item.firstBroadcastDate !== undefined && item.firstBroadcastDate !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-first-broadcast-date'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_FIRST_BROADCAST_DATE') }}:</div>
                            <div :alvqa="alvqa + '-first-broadcast-date'">
                                {{ getFormattedDate(item.firstBroadcastDate) }}
                            </div>
                        </span> 

                        <!-- Sheet number -->
                        <span v-if="item.sheetNumber !== null && item.sheetNumber !== undefined && item.sheetNumber !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-sheet-number'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER') }}:</div>
                            <div :alvqa="alvqa + '-sheet-number'">
                                {{ item.sheetNumber }}
                            </div>
                        </span> 

                        <!-- Version Type -->
                        <span v-if="item.versionTypes.length !== 0">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-version-type'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_VERSION_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-version-type'">
                                {{ getVersionTypes(item.versionTypes).join(', ') }}
                            </div>
                        </span>
                        <!-- Regions -->
                        <span v-if="Array.isArray(item.regions) && item.regions.length !== 0">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-version-regions'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_REGIONS') }}:</div>
                            <div :alvqa="alvqa + '-version-regions'">
                                 {{ getRegions(item.regions).join(', ') }}
                            </div>
                        </span> 
                        <!-- RELEASE TYPE -->
                        <span v-if="item.releaseType !== null && item.releaseType !== undefined && item.releaseType !== []">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-release-type'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_RELEASES_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-release-type'">
                                
                            {{ $alvPlugin.isLangConst(item.releaseType.text) ? $t(item.releaseType.text) : item.releaseType }}
                            </div>
                        </span>
                        
                        <!-- SYNCHRONIZATION RIGHTS -->
                        <span v-if="item.synchronizationRights !== null && item.synchronizationRights !== undefined && item.avType == 'FILM'">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-synchronization-rights'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SYNCHRONIZATION_RIGHTS') }}:</div>
                            <div :alvqa="alvqa + '-caption-synchronization-rights'">
                                <span>
                                    {{item.synchronizationRights}}
                                </span>
                                
                                <BaseTooltip>
                                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                                    <template v-slot:text>
                                        <span v-if="item.synchronizationRights == 'MEMBER'">
                                            {{ $t('lang_PUBLISHING_SHEETS_CAPTION_SYNCHRONIZATION_MEMBER_DESCRIPTION') }}
                                        </span>
                                        <span v-if="item.synchronizationRights == 'GEMA'">
                                            {{ $t('lang_PUBLISHING_SHEETS_CAPTION_SYNCHRONIZATION_GEMA_DESCRIPTION') }}
                                        </span>
                                    </template>
                                </BaseTooltip>
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-if="item.type ==='setlist' && showSecondMusicSheetTypeCard">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- Set Start Time -->
                        <span v-if="item.setDate !== null && item.setDate !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-set-date'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_DATE') }}:</div>
                            <div :alvqa="alvqa + '-set-date'">
                                {{ getFormattedDate(item.setDate) }}
                            </div>
                        </span>
                        <!-- Set Start Time -->
                        <span v-if="item.setStartTime !== null && item.setStartTime !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-set-start-time'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_START_TIME') }}:</div>
                            <div :alvqa="alvqa + '-set-start-time'">
                                {{ item.setStartTime }}
                            </div>
                        </span>
                        <!-- End Time -->
                        <span v-if="item.setEndTime !== null && item.setEndTime !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-set-end-time'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_END_TIME') }}:</div>
                            <div :alvqa="alvqa + '-set-end-time'">
                                {{ item.setEndTime }}
                            </div>
                        </span>

                        <!-- Set Type -->
                        <span v-if="item.setType !== null && item.setType !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-set-type'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_SET_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-set-type'">
                                {{ getSetType(item.setType) }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- ******** THIRD COLUMN ******** -->
            <v-col v-if="item.type ==='film/tv' && showThirdTvSheetTypeCard">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- PRODUCTION COUNTRY -->
                        <span v-if="item.productionCountry !== null && item.productionCountry !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-production-country'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_COUNTRY') }}:</div>
                            <div :alvqa="alvqa + '-production-country'">
                                {{ getProductionCountry(item.productionCountry) }}
                            </div>
                        </span>

                        <!-- REGIONS -->
                        <span v-if="item.regions !== null && item.regions !== undefined && item.regions !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-regions'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_REGIONS') }}:</div>
                            <div :alvqa="alvqa + '-regions'">
                                {{ getRegionTranslation(item.regions) }}
                            </div>
                        </span>

                        <!-- Internet-Value -->
                        <span v-if="item.internetValue !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-internet'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_INTERNET') }}:</div>
                            <div :alvqa="alvqa + '-internet'">
                                {{ getInternetValue(item.internetValue) }}
                            </div>
                        </span>
                        <!-- PLATTFORM -->
                        <span v-if="item.platform !== null && item.platform !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-platform'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_PLATFORM') }}:</div>
                            <div :alvqa="alvqa + '-platform'">
                                {{ item.platform }}
                            </div>
                        </span>
                        <!-- PROVIDER -->
                        <span v-if="item.provider !== null && item.provider !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-provider'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_PROVIDER') }}:</div>
                            <div :alvqa="alvqa + '-provider'">
                                {{ item.provider }}
                            </div>
                        </span>
                        <!-- URL -->
                        <span v-if="item.url !== null && item.url !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-url'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_URL') }}:</div>
                            <div :alvqa="alvqa + '-url'">
                                {{ item.url }}
                            </div>
                        </span>                     
                    </v-card-text>
                </v-card>
            </v-col>


            <v-col v-if="item.type ==='setlist'">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- Event name -->
                        <span v-if="item.eventName !== null && item.eventName !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-name'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NAME') }}:</div>
                            <div :alvqa="alvqa + '-event-name'">
                                {{ item.eventName }}
                            </div>
                        </span>
                      <!-- Event type -->
                        <span v-if="item.eventType !== null && item.eventType !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-type'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-event-type'">
                                {{ getEventType(item.eventType) }}
                            </div>
                        </span>                      
                        <!-- Event venue -->
                        <span v-if="item.eventVenue !== null && item.eventVenue !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-venue'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE') }}:</div>
                            <div :alvqa="alvqa + '-event-venue'">
                                {{ item.eventVenue.name }}
                            </div>
                        </span>
                        <!-- Event venue-space -->
                        <span v-if="item.eventVenueSpace !== null && item.eventVenueSpace !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-venue-space'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE_SPACE') }}:</div>
                            <div :alvqa="alvqa + '-event-venue-space'">
                                {{ item.eventVenueSpace }}
                            </div>
                        </span>
                        <!--Venue type -->
                        <span v-if="item.eventVenueType !== null && item.eventVenueType !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-venue-type'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-event-venue-type'">
                                {{ getVenueType(item.eventVenueType) }}
                            </div>
                        </span>
                        <!--Event organizer -->
                        <span v-if="item.eventOrganizer !== null && item.eventOrganizer !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-event-organizer'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_ORGANIZER') }}:</div>
                            <div :alvqa="alvqa + '-event-event-organizer'">
                                {{ item.eventOrganizer.name }}
                            </div>
                        </span>
                        <!--Event organizer yes/no -->
                        <span v-if="item.eventOrganizerYesNo !== null && item.eventOrganizerYesNo !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-event-organizer-yesno'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_ORGANIZER_YESNO') }}:</div>
                            <div :alvqa="alvqa + '-event-event-organizer-yesno'">
                                {{ isEventOrganizer(item.eventOrganizerYesNo) }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>


            <!-- 4th Column -->
            <v-col v-if="item.type ==='setlist'">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- Status -->
                        <span v-if="item.status !== null && item.status !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-status'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_STATUS') }}:</div>
                            <div :alvqa="alvqa + '-status'">
                                {{ item.status }}
                            </div>
                        </span>
                        <!-- Band leader -->
                        <span v-if="item.eventBandleader !== null && item.eventBandleader !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-band-leader'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_BANDLEADER') }}:</div>
                            <div :alvqa="alvqa + '-event-band-leader'">
                                {{ item.eventBandleader.name }}
                            </div>
                        </span>
                        <!-- Interpret-->
                        <span v-if="item.eventPerformer !== null && item.eventPerformer !== undefined">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-performer'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_PERFORMER') }}:</div>
                            <div :alvqa="alvqa + '-event-performer'">
                                {{ $alvPlugin.showNameOfAzEntry(item.eventPerformer, true) }}
                            </div>
                        </span>
                        <!-- Highest ticket price-->
                        <span v-if="item.eventHighestTicketPrice !== null && item.eventHighestTicketPrice !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-highest-ticket-price'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_HIGHEST_TICKET_PRICE') }}:</div>
                            <div :alvqa="alvqa + '-event-highest-ticket-price'">
                                {{ item.eventHighestTicketPrice }}
                            </div>
                        </span>
                        <!-- Number of concert visitors-->
                        <span v-if="item.eventNumberOfConcertgoers !== null && item.eventNumberOfConcertgoers !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-number-of-concert-goers'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NUMBER_OF_CONCERTGOERS') }}:</div>
                            <div :alvqa="alvqa + '-event-number-of-concert-goers'">
                                {{ item.eventNumberOfConcertgoers }}
                            </div>
                        </span>
                        <!-- Number of musicians-->
                        <span v-if="item.eventNumberOfMusicians !== null && item.eventNumberOfMusicians !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-event-number-of-musicians'"
                            >{{ $t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_NUMBER_OF_MUSICIANS') }}:</div>
                            <div :alvqa="alvqa + '-event-number-of-musicians'">
                                {{ item.eventNumberOfMusicians }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <WorksReadOnlyPanel :sheetAlvId="item.alvId" />
                    <PdfReadonlyPanel :sheetAlvId="item.alvId" />
                    <SheetDistributionsPanel :sheetAlvId="item.alvId"/>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

import WorksReadOnlyPanel from './_panels/1_works/WorksReadonlyPanel'
import PdfReadonlyPanel from './_panels/2_pdf/PdfReadonlyPanel'
import SheetDistributionsPanel from './_panels/3_distribution/SheetDistributionsPanel'

import 
    {   
        DropdownPublishingSheetsInternetOptions,
        DropdownPublishingSheetsEventTypeOptions,
        DropdownPublishingSheetsVenueTypeOptions,
        DropdownPublishingSheetsSetTypeOptions,
        DropdownGenericYesNo
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "SheetReadOnly",
    components:  {
        BasePanel,
        BaseButton,
        BaseTooltip,

        WorksReadOnlyPanel,
        PdfReadonlyPanel,
        SheetDistributionsPanel
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'publishing-sheets-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedSheets.find(element => {
                return element.id === this.itemId
            })

            return item
        },

        showSecondTvSheetTypeCard() {
            let productionYear = this.item.productionYear !== null && this.item.productionYear !== ''
            let firstBroadcastDate = this.item.firstBroadcastDate !== null && this.item.firstBroadcastDate !== undefined && this.item.firstBroadcastDate !== ''
            let sheetNumber = this.item.sheetNumber !== null && this.item.sheetNumber !== undefined && this.item.sheetNumber !== ''
            let versionTypes = this.item.versionTypes !== null && this.item.versionTypes !== undefined && this.item.versionTypes.length !== 0
            let regions = this.item.regions !== null && this.item.regions !== undefined && this.item.regions.length !== 0
            let releaseType = this.item.releaseType !== null && this.item.releaseType !== ''

            if(productionYear ||sheetNumber || firstBroadcastDate || versionTypes || regions || releaseType){
                return true
            }else{
                return false
            } 
            
        },
        showSecondMusicSheetTypeCard(){
            let setDate = this.item.setDate !== null && this.item.setDate !== undefined && this.item.setDate !== ''
            let setStartTime = this.item.setStartTime !== null && this.item.setStartTime !== undefined && this.item.setStartTime !== ''
            let setEndTime = this.item.setEndTime !== null && this.item.setEndTime !== undefined && this.item.setEndTime !== ''
            let setType = this.item.setType !== null && this.item.setType !== undefined && this.item.setType !== ''
            
            if(setDate ||setStartTime || setEndTime || setType ){
                return true
            }else{
                return false
            } 
        },
        showThirdTvSheetTypeCard() {
            let internetValue = this.item.internetValue !== null
            let productionCountry = this.item.productionCountry !== null && this.item.productionCountry !== ''
            let regions = this.item.regions !== null && this.item.regions !== undefined && this.item.regions !== ''
            let provider = this.item.provider !== null
            let platform = this.item.platform !== null
            let url = this.item.url !== null



            if(provider|| platform || url ||internetValue || productionCountry || regions) return true
            else return false
        },

    },
    methods: {
        getVersionTypes(versionTypes){
            let types = []
            if (Array.isArray(versionTypes)) {
                versionTypes.forEach(versionTypeObj => {
                    types.push(this.$t(versionTypeObj.text))
                });
            }
            return types
        },
        getRegions(regions){
            let regionsArray = []
            if (Array.isArray(regions)) {
                regions.forEach(region => {
                    regionsArray.push(this.$t(region.text))
                });
            }
            return regionsArray
        },
        getEventType(eventType){
            let typeOptions = DropdownPublishingSheetsEventTypeOptions

            let match = typeOptions.find(eventOption => {
                return eventOption.value === eventType
            }).text;

            return this.$t(match)
        },
        getVenueType(venueType){
            let venueOptions = DropdownPublishingSheetsVenueTypeOptions

            let match = venueOptions.find(venueOption => {
                return venueOption.value === venueType
            }).text;

            return this.$t(match)
        },
        getSetType(selectedOption) {
            let setTypeOptions = DropdownPublishingSheetsSetTypeOptions

            let match = setTypeOptions.find(option => {
                return option.value === selectedOption
            }).text

            return this.$t(match)
        },
        isEventOrganizer(selectedOption){
            let optionsList = DropdownGenericYesNo
    
            let match = optionsList.find(option => {
                return option.value === selectedOption
            }).text;

            return this.$t(match)

        },
        getFormattedDate(date) {  
            if(date === null || date === undefined || date === '') return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },
        getInternetValue(value) {
            let match = DropdownPublishingSheetsInternetOptions.find(option => {
                return option.value === value
            })

            if(match !== undefined) return this.$t(match.text)
            else return null
        },
        getProductionCountry(country) {
            if(!country) return ''
            
            try {
                const result = this.$alvPlugin.getTranslatedCountryName(country.toUpperCase(), true)
                return result || country
            } catch (error) {
                return country
            }
        },
        getRegionTranslation(regionValue) {
            // Map region values to their translation keys (from API response)
            const regionMap = {
                1: 'lang_PUBLISHING_SHEETS_CAPTION_GERMANY',
                4: 'lang_GENERIC_REGIONS_WORLD'
            }
            
            const translationKey = regionMap[regionValue]
            if (translationKey) {
                return this.$t(translationKey)
            }
            
            // Fallback: return the value if no mapping found
            return regionValue
        }
    },
    created() {
        this.$store.commit('setCountries')
    },
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>